import {Box} from 'components/Grid';
import {ModalLazyLoader} from 'components/ModalLazyLoader';
import {Typography} from 'components/Typography';
import {Breadcrumbs} from 'modules/breadcrumbs/components/Breadcrumbs';
import {Calendar} from 'modules/events/components/Calendar';
import {DayList} from 'modules/events/components/DayList';
import {EventFilterList} from 'modules/events/components/EventFilterList';
import {FC, useContext, useMemo} from 'react';
import {Modal} from 'modules/modals/components/Modal';
import {MODALS} from 'modules/modals/constants';
import dynamic from 'next/dynamic';
import style from './style.module.scss';
import {EventHallInfoModal} from 'modules/events/components/EvenaHallInfoModal';
import {TastingCertificateInfoModal} from 'modules/events/components/BannerCertificateModal';
import {LoadMoreEvents} from 'modules/events/components/LoadMoreEvents';
import {EventsListContext} from 'modules/events/context';
import {TastingSliderModal} from 'modules/events/components/TastingMediaBanner/TastingSliderModal';
import {useUserCity} from 'modules/locations/hooks/useUserCity';
import {cityIn} from 'lvovich';
import {ICity} from 'modules/locations/models';
import {IBreadcrumb} from 'modules/seo/types';

const IndividualTastingModal = dynamic(() => import('modules/events/components/IndividualTastingModal'), {
    loading: () => <ModalLazyLoader />,
});

const SelectWineryModal = dynamic(() => import('modules/wineshops-list/components/SelectWinery/Modal'), {
    loading: () => <ModalLazyLoader />,
});

const TastingSuccessModal = dynamic(() => import('modules/events/components/TastingSuccessModal'), {
    loading: () => <ModalLazyLoader />,
});

export const Events: FC<{city?: ICity; breadcrumbs?: IBreadcrumb[]}> = ({city, breadcrumbs = []}) => {
    const {canLoadMore} = useContext(EventsListContext);
    const userCity = useUserCity();
    const userCityTitle = userCity?.title;

    const cityTitle = useMemo(() => {
        const title = city?.title || userCityTitle;
        if (!title) {
            return '';
        }

        return cityIn(title);
    }, [city, userCityTitle]);

    return (
        <div>
            <Box>
                <Breadcrumbs breadcrumbs={breadcrumbs} />
            </Box>
            <Box>
                <Typography className={style.title} element={'h1'} variant={'ch-display-42-reg'}>
                    Мероприятия с дегустацией в {cityTitle}
                </Typography>
            </Box>
            <div className={style.calendar}>
                <Calendar />
            </div>
            <EventFilterList />
            <div className={style.days}>
                <DayList />
            </div>
            {canLoadMore && (
                <div className={style.loadMoreButton}>
                    <Box>
                        <LoadMoreEvents />
                    </Box>
                </div>
            )}
            <Modal name={MODALS.INDIVIDUAL_TASTING.name} hasPortal={true} willMount={true}>
                <IndividualTastingModal />
            </Modal>
            <Modal name={MODALS.SELECT_WINERY_MODAL.name} hasPortal={true} willMount={true}>
                <SelectWineryModal />
            </Modal>
            <Modal name={MODALS.TASTING_SUCCESS.name} hasPortal={true} willMount={true}>
                <TastingSuccessModal />
            </Modal>
            <Modal name={MODALS.EVENT_HALL_INFO.name} hasPortal={true} willMount={true}>
                <EventHallInfoModal />
            </Modal>
            <Modal name={MODALS.TASTING_CERTIFICATE_INFO.name} hasPortal={true} willMount={true}>
                <TastingCertificateInfoModal />
            </Modal>
            <Modal name={MODALS.DEGUSTATION_MEDIA_SLIDER.name} hasPortal={true} willMount={true}>
                <TastingSliderModal />
            </Modal>
        </div>
    );
};
